module.exports = __webpack_public_path__ + "static/img/pic_qianshoucs.25f6e502.png";